import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api, { formatApiError } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ShieldCheck, ArrowRight } from 'lucide-react';

export default function ChangePassword({ forced = false, onDone }) {
  const { user, setUser, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) return setError('Use at least 8 characters.');
    if (pw !== confirm) return setError('The two passwords don’t match.');
    setLoading(true);
    try {
      await api.post('/auth/change-password', { new_password: pw, current_password: current });
      setUser({ ...user, must_change_password: false });
      if (onDone) onDone();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="os os-page min-h-screen flex items-center justify-center p-6">
      <div className="w-full max-w-sm">
        <div className="w-12 h-12 rounded-2xl bg-[#15140f] text-white flex items-center justify-center mb-5"><ShieldCheck className="w-6 h-6" /></div>
        <h1 className="text-2xl font-extrabold tracking-tight">{forced ? 'Set your own password' : 'Change your password'}</h1>
        <p className="text-[var(--ttouch-muted)] mt-2 mb-7 text-sm">{forced ? `Welcome, ${(user?.name || '').split(' ')[0]}. For security, please replace the temporary password with one only you know.` : 'Pick a new strong password.'}</p>
        <form onSubmit={submit} className="grid gap-4" data-testid="change-password-form">
          {!forced && (
            <div className="grid gap-1.5"><Label className="font-bold text-sm">Current password</Label>
              <Input data-testid="cp-current" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="bg-white h-12" /></div>
          )}
          <div className="grid gap-1.5"><Label className="font-bold text-sm">New password</Label>
            <Input data-testid="cp-new" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="bg-white h-12" placeholder="At least 8 characters" /></div>
          <div className="grid gap-1.5"><Label className="font-bold text-sm">Confirm new password</Label>
            <Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="bg-white h-12" /></div>
          {error && <p data-testid="cp-error" className="text-sm text-red-600 font-medium">{error}</p>}
          <Button data-testid="cp-submit" type="submit" disabled={loading} className="h-12 rounded-full text-base font-bold mt-1">
            {loading ? 'Saving…' : <>Save new password <ArrowRight className="w-4 h-4 ml-1" /></>}
          </Button>
        </form>
        {forced && <button onClick={() => { logout(); }} className="text-xs text-[var(--ttouch-soft)] mt-6">Sign out instead</button>}
      </div>
    </div>
  );
}
